import { IAppEnvironment } from 'environments/config/environment.model';

export abstract class BaseRealUserMonitoringService {
  public abstract initialize(config: IAppEnvironment): void;
  public abstract setUserContext(data: unknown): void;
  public abstract logError(error: unknown): void;
}